import React from "react";
import ReactSelect from "react-select";
import Datetime from "react-datetime";
import clsx from "clsx";
import { Option } from '../../../_metronic/helpers/MySelect';
import Select, { components } from "react-select";
import { priorities, serviceTypes, statuses, ticketTypes } from "./TicketLog";
import Moment from "moment";
const { Option: customOption } = components;

interface TicketFilterProps {
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  searchData: () => void;
  removeSearch: () => void;
}

const TicketFilter: React.FC<TicketFilterProps> = ({
  state,
  setState,
  searchData,
  removeSearch,
}) => {
  return (
    <div className="collapse" id="tickets-filter" aria-labelledby="tickets-filter">
    <div className="card mt-9">
      <div className="card-body w-100 p-lg-7 p-md-7 p-5">
        <div className="row mt-6">
        <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">Apply Date filter on</label>
            <br />
            <label
              className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5 mb-1 ms-2 "
              key="apply_date_1"
            >
              <input
                className="form-check-input"
                type="radio"
                name="applyDateFilterOn"
                value='reportedAt'
                checked={state.applyDateFilterOn === 'reportedAt'}
                onChange={() =>
                  setState({
                    applyDateFilterOn: 'reportedAt'
                  })
                }
              />
              <span className="form-check-label fs-5 mb-0 ms-2">
                Reported at
              </span>
            </label>
            <label
              className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
              key="apply_date_3"
            >
              <input
                className="form-check-input"
                type="radio"
                name="applyDateFilterOn"
                value='closedAt'
                checked={state.applyDateFilterOn === 'closedAt'}
                onChange={() =>
                  setState({
                    applyDateFilterOn: 'closedAt'
                  })
                }
              />
              <span className="form-check-label fs-5 mb-0 ms-2">
                Closed at
              </span>
            </label>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold"> From Date</label>
            <Datetime
              dateFormat="YYYY-MM-DD"
              timeFormat="HH:mm"
              ref={state.resetFrom}
              closeOnSelect
              value={state.filterFromDate ? Moment(state.filterFromDate).format("YYYY-MM-DD HH:mm") : ""}
              onChange={(e: any) => {
                const dt = e["_d"];
                setState({
                  filterFromDate: dt,
                });
              }}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">To Date</label>
            <Datetime
              dateFormat="YYYY-MM-DD"
              timeFormat="HH:mm"
              ref={state.resetTo}
              closeOnSelect
              value={state.filterToDate ? Moment(state.filterToDate).format("YYYY-MM-DD HH:mm") : ""}
              onChange={(e: any) => {
                const dt = e["_d"];
                setState({
                  filterToDate: dt,
                });
              }}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">Ticket Id</label>
            <input
              autoComplete="off"
              className={clsx("form-control")}
              name="filterTicketId"
              value={state.filterTicketId}
              onChange={(event: any) => {
                setState({
                  filterTicketId: event.target.value,
                });
              }}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">Ticket Type</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  ticketTypeSelected: selected,
                  filterTicketType: value,
                });
              }}
              components={{
                Option,
              }}
              value={state.ticketTypeSelected}
              options={Array.from(ticketTypes).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.name,
                  };
                }
              )}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">Machines</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              name="machineId"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  machineSelected: selected,
                  filterMachine: value,
                });
              }}
              components={{
                Option,
              }}
              value={state.machineSelected}
              options={Array.from(state.machineDB).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: `${value.name ? value?.name : (value?.location?.name  ?? "")} ${value?.serialNumber}`,
                  };
                }
              )}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Ticket Source</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              name="machineId"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  ticketSourceSelected: selected,
                  filterTicketSource: value,
                });
              }}
              components={{
                Option,
              }}
              value={state.ticketSourceSelected}
              options={Array.from(state.ticketSourceDB).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.name,
                  };
                }
              )}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Service Type</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  serviceTypeSelected: selected,
                  filterServiceType: value,
                });
              }}
              components={{
                Option,
              }}
              value={state.serviceTypeSelected}
              options={Array.from(serviceTypes).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.name,
                  };
                }
              )}
            />

          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Assign To</label>
            <Select
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              name="status"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              value={state.assignSelected}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  assignSelected: selected,
                  filterAssign: value,
                });
              }}
              components={{
                Option,
              }}
              options={Array.from(state.assignToDB).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.firstName,
                  };
                }
              )}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Reported By</label>
            <Select
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              name="reportedBy"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              value={state.reportedBySelected}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  reportedBySelected: selected,
                  filterReportedBy: value,
                });
              }}
              components={{
                Option,
              }}
              options={Array.from(state.assignToDB).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.firstName,
                  };
                }
              )}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Priority</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  prioritySelected: selected,
                  filterPriority: value,
                });
              }}
              components={{
                Option,
              }}
              value={state.prioritySelected}
              options={Array.from(priorities).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.name,
                  };
                }
              )}
            />
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">
              Machine status
            </label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  machineStatusSelected: selected,
                  machineStatus: value,
                });
              }}
              components={{
                Option: customOption,
              }}
              value={state.machineStatusSelected}
              options={Array.from(state.machineStatusDB).map(
                (value: any) => {
                  return {
                    value: value.id,
                    label: value.name,
                    description: value.description,
                  };
                }
              )}
              formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                let isChecked = false;
                const filter = selectValue.filter((x: any) => x.value === value);
                if (filter.length > 0) {
                  isChecked = true;
                }
                return context === 'menu' ? (
                  <div>
                    <label className="form-check form-check-custom form-check-solid">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isChecked}
                        readOnly
                      />
                      <label style={{marginLeft: '5px'}}>{label}</label>
                    </label>
                    <div className="text-muted">{description}</div>
                  </div>
                ) : (
                  label
                );
              }}
            />
          </div>
         
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fs-4 fw-bold">Serial Number</label>
            <input
              autoComplete="off"
              className={clsx("form-control")}

              name="filterSerialNumber"
              value={state.filterSerialNumber}
              onChange={(event: any) => {
                setState({
                  filterSerialNumber: event.target.value,
                });
              }}
            />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
            <label className="form-label fw-bold fs-4">Status</label>
            <ReactSelect
              className="react-select"
              classNamePrefix="my-react-select"
              placeholder=""
              isMulti
              name="status"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              value={state.statusSelected}
              onChange={(selected: any) => {
                const value = selected?.map((e: any) => e.value);
                setState({
                  statusSelected: selected,
                  filterStatus: value,
                });
              }}
              components={{
                Option,
              }}
              options={Array.from(statuses).map((value: any) => {
                return {
                  value: value.id,
                  label: value.name,
                };
              })}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
            <button
              type="submit"
              onClick={searchData}
              className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
            >
              {state.addLoading && (
                <span
                  className="indicator-progress"
                  style={{ display: "block" }}
                >
                  Please Wait..
                  <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                </span>
              )}
              {!state.addLoading && (
                <span className="indicator-label">ADD FILTER</span>
              )}
            </button>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
            <button
              type="submit"
              onClick={removeSearch}
              className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
            >
              {state.filterLoading && (
                <span
                  className="indicator-progress"
                  style={{ display: "block" }}
                >
                  Please Wait..
                  <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                </span>
              )}
              {!state.filterLoading && (
                <span className="indicator-label">RESET FILTER</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default TicketFilter;